import * as Sentry from "@sentry/react";
import { useFetchApi } from "./useFetchApi";
import { PolicySummary } from "shared";
import { apiRoutes } from "../routing/routes";

/** @returns An array of policies or undefined if the call failed */
export const usePolicySummaries = (hasStandaloneFuturePolicies?: boolean) => {
  const params = hasStandaloneFuturePolicies
    ? `?hasStandaloneFuturePolicies=${hasStandaloneFuturePolicies}`
    : "";
  const path = apiRoutes.policiesSummary + params;

  try {
    return useFetchApi<PolicySummary[]>(path).data;
  } catch (error) {
    // This is needed due to how npm package fetch-suspense works.
    if (error instanceof Promise) {
      throw error;
    }

    Sentry.captureException(error, {
      contexts: {
        context: {
          message: "Unable to fetch household policies on account settings",
        },
      },
    });

    return undefined;
  }
};
